export default {
  methods: {
    getBaseModuleFromFullModule(fullModule) {
      for (const lang of this.languageConfigs) {
        if (lang.suffix !== "" && fullModule.includes(lang.suffix)) {
          return fullModule.replace(lang.suffix, "");
        }
      }
      return fullModule;
    },
    getTemplateForLanguage(templateModule, languageCode) {
      const language = this.languages.find((lang) => lang.code === languageCode);
      if (language) {
        const templateObj =
          language.templates.find((t) => t.module === `${templateModule}${language.suffix}`) || {
            module: `${templateModule}${language.suffix}`,
            label: templateModule,
            mailTemplateId: "",
            cc: "",
            bcc: "",
            senderMail: "",
            reminderHours: "",
          };
        return templateObj;
      }
      return {
        module: templateModule,
        label: templateModule,
        mailTemplateId: "",
        cc: "",
        bcc: "",
        senderMail: "",
        reminderHours: "",
      };
    },
    getLanguageCodeFromModule(module) {
      for (const lang of this.languageConfigs) {
        if (lang.suffix !== "" && module.includes(lang.suffix)) {
          return lang.code;
        }
      }

      if (!module.includes("De") && !module.includes("Fr") && !module.includes("Tu") && !module.includes("Es")) {
        return "en";
      }

      return "en";
    },
    initializeLanguages() {
      this.languages = this.languageConfigs.map((lang) => ({
        ...lang,
        cc: "",
        bcc: "",
        senderMail: "",
        templates: this.baseTemplates.map((template) => ({
          module: `${template.module}${lang.suffix}`,
          label: template.label,
          mailTemplateId: "",
        })),
      }));
    },
    async createTemplate() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          try {
            this.$store.commit("showLoader", true);
            const modules = this.baseTemplates.flatMap((template) => {
              const sharedData = this.getTemplateForLanguage(template.module, "en");
              return this.languages.map((lang) => {
                const templateData = this.getTemplateForLanguage(template.module, lang.code);
                return {
                  module: templateData.module,
                  mailTemplateId: templateData.mailTemplateId?.id ?? "",
                  cc: sharedData.cc || "",
                  bcc: sharedData.bcc || "",
                  senderMail: sharedData.senderMail || "",
                  reminderHours: sharedData.reminderHours || "",
                  id: templateData.id,
                };
              });
            });

            await this.$store.dispatch("mailTemplates/mailTemplateAssignmentSave", {
              modules: modules,
            });
          } catch (e) {
            console.error("api error ___", e);
          } finally {
            this.$store.commit("showLoader", false);
          }
        }
      });
    },
  },
};
